import { LOTTIE_VISUAL } from '../elements/lottie'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { LINK_TITLE } from '../elements/link'
import { ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'

export const CONTENT_TWO_COLUMN_GRID = `
...on contentTwoColumnGrid_Entry {
  id
  typeHandle
  anchorId
  
  headingAdvanced {
    html
  }
  description

  ${ LINK_TITLE }

  contentCards {
    id
    typeHandle

    eyebrow
    headline

    badge
    badgeMode

    title
    description

    ... on contentCardV2_Entry {
      ${ LOTTIE_VISUAL }
      id
      ${ CONVERSATION_BOX }
    }

    ${ ASSET_DESKTOP }
    ${ ASSET_MOBILE }

    ${ LINK_TITLE }
  }
  
}
`